import { Component, OnInit } from '@angular/core';
import { RequestMoneyService } from '../request-money.service';

@Component({
  selector: 'app-request-step1',
  templateUrl: './request-step1.component.html',
  styleUrls: ['./request-step1.component.scss']
})
export class RequestStep1Component implements OnInit {

  constructor(public requestMoneyervice:RequestMoneyService) { }

  ngOnInit(): void {
    this.requestMoneyervice.setRequestMethods()
  }

  goNext(){
    this.requestMoneyervice.goTo('step2')
  }

  goBack(){
    this.requestMoneyervice.router.navigateByUrl("/dashboard")
  }

  selectReceivingMethod(item){
    this.requestMoneyervice.step1Data=item
  }

}
